import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import { WhatsAppProvider } from './contexts/WhatsAppContext';
import Loading from './components/Loading';
import { NotificationProvider } from './contexts/NotificationContext';

const AppRoutes = React.lazy(() => import('./routes'));

const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <NotificationProvider>
          <ToastProvider>
            <WhatsAppProvider>
              <AuthProvider>
                <Suspense fallback={<Loading />}>
                  <AppRoutes />
                </Suspense>
              </AuthProvider>
            </WhatsAppProvider>
          </ToastProvider>
        </NotificationProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;